module.exports = __webpack_public_path__ + "img/ic_logout.9573471a.svg";